"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NativeSelect = void 0;

var tslib_1 = require("tslib");

var ui_blocks_1 = require("@hopin-team/ui-blocks");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_props_to_styles_1 = require("@hopin-team/ui-helper-props-to-styles");

var ui_symbols_1 = require("@hopin-team/ui-symbols");

var styled_components_1 = tslib_1.__importStar(require("styled-components"));

var field = ui_blocks_1.FORM.field; // Sizes =======================================================================

var Sizes;

(function (Sizes) {
  Sizes[Sizes["small"] = 4] = "small";
  Sizes[Sizes["medium"] = 5] = "medium";
})(Sizes || (Sizes = {}));

var PositionX;

(function (PositionX) {
  PositionX[PositionX["small"] = 97] = "small";
  PositionX[PositionX["medium"] = 96] = "medium";
})(PositionX || (PositionX = {}));

var PositionY;

(function (PositionY) {
  PositionY[PositionY["small"] = 0.5] = "small";
  PositionY[PositionY["medium"] = 0.8] = "medium";
})(PositionY || (PositionY = {}));

var makeSizeStyles = function makeSizeStyles(size) {
  return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  height: ", ";\n  background-position-x: ", "%;\n  background-position-y: ", "rem;\n"], ["\n  height: ", ";\n  background-position-x: ", "%;\n  background-position-y: ", "rem;\n"])), (0, ui_symbols_1.calcSpace)(Sizes[size]), PositionX[size], PositionY[size]);
};

exports.NativeSelect = styled_components_1.default.select(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  ", "\n\n  appearance: none;\n  width: 100%;\n\n  background-color: ", ";\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16px' height='16px' viewBox='0 0 24 24'%3E%3Cpath fill='%23696E7C' d='M21.695 5.177a.6.6 0 01.851 0l1.272 1.272a.576.576 0 010 .84L12.792 18.316a.9.9 0 01-.636.263h-.312a.9.9 0 01-.636-.264L.182 7.29a.576.576 0 010-.84l1.272-1.272a.6.6 0 01.851 0L12 14.872l9.695-9.695z'%3E%3C/path%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n\n  ", "\n"], ["\n  ", "\n\n  appearance: none;\n  width: 100%;\n\n  background-color: ", ";\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16px' height='16px' viewBox='0 0 24 24'%3E%3Cpath fill='%23696E7C' d='M21.695 5.177a.6.6 0 01.851 0l1.272 1.272a.576.576 0 010 .84L12.792 18.316a.9.9 0 01-.636.263h-.312a.9.9 0 01-.636-.264L.182 7.29a.576.576 0 010-.84l1.272-1.272a.6.6 0 01.851 0L12 14.872l9.695-9.695z'%3E%3C/path%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n\n  ", "\n"])), field, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.WHITE', theme);
}, function (props) {
  return (0, ui_helper_props_to_styles_1.makeStyles)(props, 'sizeOption', makeSizeStyles);
});
var templateObject_1, templateObject_2;